/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React, {useState} from 'react';
import {Platform, View} from 'react-native';
import {connect} from 'react-redux';

import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import SubmitButtons from '../../../components/Button/SecondaryButton';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {InputField} from '../../../components/Inputs/InputField';

import {getNextDay, handleDateValue} from '../../../../common/utils/date';
import {getTypeContratPayment} from '../../../../common/utils/paiement';
import {Validation} from '../../../../common/utils/paiement/validationTelma';
import {separateurMillier} from '../../../../common/utils/rendering';
import config from '../../../../data/config';
import {
  defaultTelmaErrorValues,
  ERROR_MESSAGE,
  redirectRoutesAfterPayment,
  showErrorTelmaValuesDefault,
  showErrorTelmaValuesSubmit,
  SUCCESS_MESSAGE,
  TRANSACTION_ERROR_MSG,
} from '../../../../data/constants/paiement';
import {
  formatDataForRapatriementRenewal,
  sendInfo,
} from '../../../../data/factory/paiement';
import {IMvola, IMvolaError} from '../../../../data/types/interface/paiement';
import {StackParams} from '../../../../data/types/navigation';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import LoaderWithMessage from '../../../components/LoaderWithMessage';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';

type NavigationProps = StackNavigationProp<StackParams>;

export const TelmaPaymentForm = (props: any) => {
  const {mvolaUser, user, mvolaTransactionUser} = props;

  const {contratEC = {}} = props?.user || {};
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [transactionId, setTransactionId] = useState<string>('');

  const primTTC = contratEC.primeTTC || contratEC.montant || 0;
  const premierVersement = contratEC.premierVersement
    ? contratEC.premierVersement
    : 0;

  console.log(contratEC.dateEffet, contratEC.dateDebut);

  const nextDay: Date = React.useMemo(() => {
    console.log(
      dayjs(contratEC.dateEffet).toDate() ||
        dayjs(contratEC.dateDebut).toDate() ||
        getNextDay(new Date(handleDateValue(contratEC.dateEcheance))),
    );

    return (
      dayjs(contratEC.dateEffet).toDate() ||
      dayjs(contratEC.dateDebut).toDate() ||
      getNextDay(new Date(handleDateValue(contratEC.dateEcheance)))
    );
  }, [contratEC]);

  const [values, setValues] = React.useState<IMvola>({
    montant:
      contratEC.typeContrat === undefined &&
      contratEC.typePayment !== 'prime' &&
      contratEC.typePayment !== 'renouvellement'
        ? 0
        : contratEC.typeContrat === 'retraite'
        ? premierVersement
        : primTTC,
    clientNumber: '',
    motif: '',
    typeContrat: contratEC.typeContrat,
    nom: 'nom',
    simulationId: contratEC.simulationId,
    numeroPolice: contratEC.numeroPolice,
    dateEffet: nextDay.toString() ?? '',
  });

  const [error, setError] = React.useState<IMvolaError>(
    defaultTelmaErrorValues,
  );
  const [showErrors, setShowErrors] = useState(showErrorTelmaValuesDefault);
  const [IsLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleCancel = () => {
    goBack();
  };
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoMessage, setInfoMessage] = useState('');

  const showInfoMessage = (message: string) => {
    setInfoMessage(message);
    setShowInfoModal(true);
  };

  const sendPayment = () => {
    values.montant = +values.montant.toString().replace(/[^0-9]/g, '');

    const contrat = contratEC.typeContrat;
    if (
      contrat === 'retraite' ||
      (contratEC.typeContratPayment === 'retraite' &&
        (contratEC.primeTTC === '' || contratEC.typeContrat === undefined))
    ) {
      values.typeContrat = 'retraite';
      values.simulationId = contratEC.simulationId;
    } else {
      values.typeContrat = getTypeContratPayment(
        contrat,
        contratEC?.typeContratPayment,
      );
    }

    values.nom =
      user?.data?.utilisateur?.nom + ' ' + user?.data?.utilisateur?.prenom;

    const extraInformation =
      values.typeContrat == 'rapatriement'
        ? formatDataForRapatriementRenewal(contratEC)
        : {};

    mvolaUser(
      {
        ...values,
        typePayment: contratEC.typePayment ?? '',
        dateEffet: values.dateEffet
          ? dayjs(values.dateEffet).isValid()
            ? dayjs(values.dateEffet).format('DD/MM/YYYY')
            : values.dateEffet
          : dayjs().format('DD/MM/YYYY'),
        numeroPolice: props.user.numeroPolice,
        ...extraInformation,
      },
      (res: any) => {
        if (res) {
          if (res?.mvolaResponse?.data?.transactionId) {
            setIsLoading(true);
            setTimeout(() => {
              mvolaTransactionUser(
                {},
                (resGet: any) => {
                  setIsLoading(false);
                  if (resGet?.mvolaTranscationResponse?.data !== 'Succès') {
                    showErrorMessage(TRANSACTION_ERROR_MSG);
                  } else {
                    setTransactionId(
                      () => res.mvolaResponse.data.transactionId,
                    );
                    showInfoMessage(SUCCESS_MESSAGE);
                  }
                },
                `?transactionId=${res.mvolaResponse.data.transactionId}&typeContrat=${values.typeContrat}`,
              );
            }, 30 * 1000);
          } else {
            setErrorMessage(ERROR_MESSAGE);
            setShowErrorModal(true);
          }
        }
      },
    );
  };

  const showErrorMessage = (message: string) => {
    setErrorMessage(message);
    setShowErrorModal(true);
  };

  const handleSubmit = () => {
    setShowErrors(showErrorTelmaValuesSubmit);
    setError(Validation(contratEC, values));
    if (noError(Validation(contratEC, values))) {
      setIsLoading(true);
      sendPayment();
    }
  };

  const redirectToHome = (paramsSend: any) => {
    setIsLoading(false);
    console.log('redirect after paiment', paramsSend);

    const route = redirectRoutesAfterPayment[paramsSend.title];

    if (route) {
      navigate(route, {id: paramsSend.id});
    } else if (paramsSend.numeroPolice) {
      navigate('DetailContrat', paramsSend);
    } else {
      navigate('Home');
    }
  };
  const infoOkCompletion = () => {
    setShowInfoModal(false);
    setIsLoading(true);
    sendInfo({
      ...props,
      user: {
        ...props.user,
        contratEC: {
          ...props.user.contratEC,
          dateEffet: values.dateEffet,
          transactionId,
        },
      },
      okCompletion: redirectToHome,
      showError: showErrorMessage,
      setIsLoading: () => {
        setIsLoading(false);
      },
    });
  };

  const noError = (validate: any) => {
    let bNoError = true;
    Object.values(validate).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors(prevShowErrors => ({
      ...prevShowErrors,
      nom: false,
      montant: false,
      motif: false,
      clientNumber: false,
      typeContrat: false,
      dateEffet: false,
    }));
    setValues((prevValues: IMvola) => ({...prevValues, [name]: value}));

    setError(Validation(contratEC, {...values, [name]: value}));
  };
  const backToMonEspace = () => {
    setShowErrorModal(false);
    setIsLoading(false);
    navigate('MonEspace');
  };

  useFocusEffect(
    React.useCallback(() => {
      setValues({
        montant:
          contratEC.typeContrat === undefined &&
          contratEC.typePayment !== 'prime' &&
          contratEC.typePayment !== 'renouvellement'
            ? 0
            : contratEC.typeContrat === 'retraite'
            ? premierVersement
            : primTTC,
        clientNumber: '',
        motif: '',
        typeContrat: 'retraite',
        nom: 'nom',
        simulationId: contratEC.simulationId,
        numeroPolice: contratEC.numeroPolice,
        dateEffet:
          contratEC.typePayment === 'souscription'
            ? contratEC.dateEffet
            : nextDay.toISOString() || '',
      });
    }, [contratEC]),
  );

  return (
    <View style={{flex: 1}}>
      <HeaderScreen title="Mvola" type="retour" noBreadcrumb={false} />
      <View style={{flex: 1, backgroundColor: 'white'}}>
        <LoaderWithMessage isLoading={IsLoading} />
        {!IsLoading && (
          <View style={{flex: 1, paddingTop: 20, paddingHorizontal: 20}}>
            <View>
              <InputField
                label={
                  contratEC.typeContrat === undefined &&
                  contratEC.typePayment === 'cotisation'
                    ? 'Montant (minimum : 2000 Ar)'
                    : 'Montant (Ar)'
                }
                required
                value={
                  values.montant === 0 ? '' : separateurMillier(values.montant)
                }
                name="montant"
                type="price"
                onChange={handleChange}
                error={error.montant}
                showError={showErrors.montant}
                isEditable={
                  contratEC.typePayment === 'cotisation' ||
                  contratEC.typeContrat === 'retraite' ||
                  !!config.montantEditable
                }
                // isEditable
              />
              {contratEC.typeContrat != 'rcvp' &&
              contratEC.typeContrat != 'scolaire' &&
              contratEC.typeContrat != 'rattache' &&
              (contratEC.typePayment === 'prime' ||
                contratEC.typePayment === 'renouvellement') ? (
                <InputDatePicker
                  label={"Date d'effet"}
                  required
                  value={values.dateEffet}
                  name="dateEffet"
                  onChange={handleChange}
                  dateMin={getNextDay(
                    new Date(handleDateValue(contratEC.dateEcheance)),
                  )}
                  isEditable={!(contratEC.typePayment != 'rapatriement')}
                />
              ) : null}
              <InputField
                label="Numéro de téléphone"
                required
                value={values.clientNumber}
                name="clientNumber"
                onChange={handleChange}
                error={error.clientNumber}
                showError={showErrors.clientNumber}
                maxLength={15}
                type="telephone"
              />
              <InputField
                label="Motif"
                required
                value={values.motif}
                name="motif"
                onChange={handleChange}
                error={error.motif}
                showError={showErrors.motif}
                maxLength={20}
              />
            </View>
            <View
              style={
                Platform.OS !== 'web'
                  ? {
                      position: 'absolute',
                      marginLeft: 20,
                      bottom: 0,
                      width: '100%',
                    }
                  : null
              }>
              <SubmitButtons
                cancelAction={handleCancel}
                submitAction={handleSubmit}
                cancelTitle="Annuler"
                submitTitle="Valider"
              />
            </View>
          </View>
        )}

        {/* TODO - test : remove */}
        {/** Error modal */}
        {showInfoModal && (
          <ConfirmationModal
            title="Information"
            content={infoMessage}
            btn1="OK"
            handleBtn1={infoOkCompletion}
          />
        )}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={backToMonEspace}
          />
        )}
      </View>
    </View>
  );
};

export const TelmaPayment: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TelmaPaymentForm);
